<script>
/**
 * As redes que o contato pode ter, com o ícone e o prefixo de URL de cada uma.
 *
 * Exportada porque o painel da conversa (#1243) mostra as mesmas redes como
 * linhas rótulo/valor em vez de uma fileira de ícones — e duas cópias desta
 * tabela sairiam do ar uma da outra na primeira rede nova. O `label` é nome de
 * marca e por isso não passa pelo i18n.
 */
export const SOCIAL_MEDIA_LINKS = [
  {
    key: 'facebook',
    label: 'Facebook',
    icon: 'brand-facebook',
    link: 'https://facebook.com/',
  },
  {
    key: 'twitter',
    label: 'Twitter',
    icon: 'brand-twitter',
    link: 'https://twitter.com/',
  },
  {
    key: 'linkedin',
    label: 'LinkedIn',
    icon: 'brand-linkedin',
    link: 'https://linkedin.com/',
  },
  {
    key: 'github',
    label: 'GitHub',
    icon: 'brand-github',
    link: 'https://github.com/',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    icon: 'brand-instagram',
    link: 'https://instagram.com/',
  },
  {
    key: 'line',
    label: 'LINE',
    icon: 'brand-line',
    link: 'https://line.me/R/ti/p/~',
  },
  {
    key: 'telegram',
    label: 'Telegram',
    icon: 'brand-telegram',
    link: 'https://t.me/',
  },
  {
    key: 'phone',
    label: 'WhatsApp',
    icon: 'brand-whatsapp',
    link: 'https://wa.me/',
  },
  { key: 'website', label: 'Website', icon: 'globe', link: 'https://' },
];

/**
 * As redes de um contato, prontas para consulta por `key` da tabela acima.
 *
 * Duas fontes entram aqui e não são campos de `social_profiles`:
 *   - `phone`, que é o próprio telefone do contato (o `wa.me` do WhatsApp);
 *   - `twitter`, que em contato antigo mora em `screen_name` -- o webhook do
 *     Twitter gravava lá antes de existir o objeto aninhado. O valor novo vem
 *     depois no spread e ganha do legado, de propósito.
 */
export const socialProfilesOf = contact => {
  const { additional_attributes: additionalAttributes = {} } = contact || {};
  const { social_profiles: socialProfiles, screen_name: twitterScreenName } =
    additionalAttributes || {};

  return {
    twitter: twitterScreenName,
    phone: contact?.phone_number,
    ...(socialProfiles || {}),
  };
};

export default {
  props: {
    socialProfiles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      socialMediaLinks: SOCIAL_MEDIA_LINKS,
    };
  },
  computed: {
    availableProfiles() {
      return this.socialMediaLinks.filter(
        mediaLink => !!this.socialProfiles[mediaLink.key]
      );
    },
  },
};
</script>

<template>
  <div v-if="availableProfiles.length" class="flex items-end mx-0 my-2 gap-3">
    <a
      v-for="profile in availableProfiles"
      :key="profile.key"
      :href="`${profile.link}${socialProfiles[profile.key]}`"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <fluent-icon
        :icon="profile.icon"
        size="16"
        class="text-subtle hover:text-primary-500 dark:hover:text-primary-400 transform hover:scale-125 transition-all duration-300 ease-out"
      />
    </a>
  </div>
</template>
